<template>
  <div class="app-header">
    <the-navigation-drawer :nav-items="navItems" navigation-title="Navigation" />
    <the-navigation-bar :nav-items="navItems" />
  </div>
</template>

<script>
import TheNavigationDrawer from './TheNavigationDrawer'
import TheNavigationBar from './TheNavigationBar'

export default {
  name: 'the-header',
  components: {
    TheNavigationDrawer,
    TheNavigationBar
  },
  data: () => ({
    navItems: [{
      text: 'Users',
      link: '/users',
      icon: 'person'
    },
    {
      text: 'User Groups',
      link: '/user-groups',
      icon: 'group'
    },
    {
      text: 'Clients',
      link: '/clients',
      icon: 'account_balance'
    },
    {
      text: 'Client Databases',
      link: '/client-databases',
      icon: 'storage'
    },
    {
      text: 'Client Documents',
      link: '/client-documents',
      icon: 'description'
    },
    {
      text: 'Roles',
      link: '/roles',
      icon: 'work'
    },
    {
      text: 'Okta Federations',
      link: '/okta-federations',
      icon: 'settings_input_antenna'
    }
    ]
  })
}
</script>
